function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "selection");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M727.67315,818.93455q-42.35181-7.17511-81.4599-12.324l10.30689-19.98364c-3.47551-1.20711-18.745,10.23693-18.745,10.23693l13.52613-58.00768c-17.47959,2.108-26.36686,61.33735-26.36686,61.33735l-19.52924-20.02506,9.45473,22.51341c-79.79594-9.39718-148.71032-12.8815-206.67542-13.00709l8.82168-17.1039c-3.47551-1.20711-18.745,10.23692-18.745,10.23692l13.52613-58.00768c-17.47959,2.108-26.36686,61.33736-26.36686,61.33736l-19.52924-20.02507,10.01406,23.8454a1160.95106,1160.95106,0,0,0-118.809,8.07024C266.01891,771.38327,296.33,746.042,296.33,746.042c-23.1484,6.88469-35.291,18.42147-41.63586,29.17709a467.19755,467.19755,0,0,1,27.004-161.42283s-47.847,104.11925-41.74176,174.00846l.73023,12.41031c-40.56344,5.80815-60.95691,11.851-60.95691,11.851Z",
  transform: "translate(-179.72968 -81.06545)",
  fill: "#3f3d56"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M524.43633,681.065l-.00049-2c3.97657-.001,8.01319-.083,11.999-.24219l.08007,1.99805C532.50274,680.982,528.43926,681.064,524.43633,681.065Zm-12.07519-.23145c-3.998-.15625-8.05469-.3955-12.05664-.71093l.15722-1.99414c3.97608.31445,8.00586.55175,11.97754.707Zm36.21045-.7373-.15918-1.99414c3.96875-.31738,7.98535-.7207,11.9375-1.19824l.24023,1.98633C556.61114,679.37062,552.56768,679.7759,548.57159,680.09621Zm-60.28711-1.166c-3.9878-.47753-8.01221-1.041-11.96241-1.6748l.31739-1.97461c3.92334.62988,7.92138,1.18945,11.88232,1.66309Zm84.26513-1.72851-.31933-1.97461c3.92236-.63379,7.89355-1.35938,11.80322-2.1543l.39844,1.959C580.49639,675.83351,576.49834,676.563,572.54961,677.20168Zm-108.1123-2.10254c-3.936-.79688-7.90186-1.68457-11.78858-2.63574l.47559-1.94336c3.86084.94629,7.80029,1.82715,11.70947,2.61816Zm131.78076-2.7168-.47852-1.9414c3.87256-.95313,7.772-1.99707,11.59034-3.10352l.55664,1.92188C604.0418,670.37258,600.116,671.42336,596.21807,672.38234Zm-155.2417-3.03027c-3.85644-1.11328-7.73779-2.31836-11.53613-3.582l.63183-1.89844c3.77295,1.25586,7.62842,2.45313,11.459,3.55859Zm178.44141-3.68945-.63379-1.89649c3.77539-1.26172,7.57715-2.61816,11.30078-4.0332l.71094,1.86914C627.04668,663.02687,623.21856,664.39309,619.41778,665.66262Zm-201.39014-3.95215c-3.752-1.42188-7.53125-2.94141-11.2334-4.51856l.78369-1.83984c3.67725,1.56641,7.43164,3.07617,11.15869,4.4873Zm223.93994-4.61231-.78515-1.83984c3.65625-1.56152,7.32714-3.2168,10.91015-4.9209l.85938,1.80664C649.34453,653.85891,645.64825,655.5259,641.96758,657.09816Zm-246.21191-4.875c-3.63282-1.72461-7.27491-3.54492-10.82471-5.41113l.93066-1.76953c3.52588,1.85254,7.14307,3.66113,10.75147,5.374Zm267.97656-5.47461-.93164-1.76953c3.52246-1.85351,7.05078-3.80176,10.48633-5.78906l1.00195,1.73047C670.82989,642.92141,667.27813,644.88234,663.73223,646.74855Zm-289.395-5.77929c-3.48535-2.01465-6.96631-4.12207-10.34668-6.26367l1.07031-1.68946c3.35742,2.127,6.81543,4.22071,10.27735,6.22266Zm310.269-6.29883-1.07031-1.68945c3.35254-2.124,6.71484-4.34961,9.99316-6.61622l1.13672,1.64454C691.366,630.29152,687.98125,632.53273,684.60625,634.67043ZM353.907,628.03273c-3.30712-2.28515-6.606-4.66406-9.80517-7.07129l1.20215-1.59765c3.17822,2.39062,6.45508,4.7539,9.73974,7.02441Zm350.54688-7.084-1.20313-1.59766c3.1709-2.38476,6.34571-4.874,9.43653-7.39941l1.26562,1.54883C710.8416,616.0425,707.64532,618.54836,704.45391,620.94875Zm-369.86377-7.44629c-3.105-2.53711-6.20117-5.17187-9.20264-7.832l1.32618-1.49609c2.98193,2.6416,6.05761,5.25976,9.14208,7.77929Zm388.55811-7.82715-1.32618-1.49609c2.9795-2.64063,5.94629-5.37793,8.81739-8.13477l1.38476,1.44336C729.13457,600.26223,726.14825,603.01711,723.14825,605.67531ZM316.50713,597.479c-2.88476-2.77148-5.75928-5.64453-8.543-8.53906l1.44141-1.38672c2.76562,2.876,5.62109,5.73047,8.4873,8.48242Zm424.061-8.53125-1.44141-1.38672c2.75684-2.86718,5.49609-5.833,8.14258-8.8164l1.49609,1.32812C746.10137,583.07473,743.34356,586.06105,740.56817,588.94777Zm-440.79737-8.8789c-2.6665-3.00586-5.30078-6.09864-7.83056-9.19239l1.54883-1.26562c2.5122,3.07324,5.12939,6.14551,7.77783,9.12988Zm456.83155-9.19434-1.54883-1.26562c2.52734-3.08985,5.02148-6.26758,7.41406-9.44434l1.59766,1.20312C761.657,564.56594,759.14532,567.76418,756.60235,570.87453Zm-472.11621-9.49219c-2.41016-3.20019-4.7876-6.49121-7.06592-9.7832l1.64453-1.13867c2.26318,3.27051,4.62451,6.54,7.019,9.71875Zm486.65625-9.8164-1.64454-1.13672c2.27149-3.28516,4.50391-6.6543,6.63379-10.01367l1.68946,1.07031C775.67657,544.86769,773.4295,548.2593,771.14239,551.56594ZM270.75371,541.5425c-2.14306-3.37891-4.24755-6.84863-6.25537-10.31348l1.73047-1.00195c1.99414,3.44141,4.085,6.88769,6.21338,10.24414ZM784.0916,531.14309l-1.73046-1.002c2.002-3.46,3.95605-7,5.80859-10.52051l1.76953.93164C788.075,524.09621,786.10723,527.65969,784.0916,531.14309ZM258.66534,520.67336c-1.86329-3.53809-3.68067-7.16406-5.40137-10.77735l1.80566-.85937c1.70947,3.58887,3.51465,7.19043,5.36524,10.70508ZM795.35625,509.731l-1.80664-.85938c1.71192-3.60156,3.375-7.28906,4.94141-10.96094l1.83984.78516C798.75371,502.39211,797.07989,506.105,795.35625,509.731ZM248.30352,498.91555c-1.5752-3.6836-3.09277-7.44141-4.51123-11.16993l1.86914-.71093c1.40918,3.70215,2.9165,7.43554,4.481,11.09375ZM804.85625,487.4634l-1.87011-.709c1.418-3.74121,2.77734-7.55468,4.03808-11.333l1.89649.63281C807.65215,479.85891,806.284,483.6968,804.85625,487.4634ZM239.72588,476.37062c-1.27344-3.80175-2.48535-7.68164-3.602-11.53027l1.9209-.55664c1.10937,3.82227,2.313,7.67578,3.57764,11.45215Zm572.78467-11.85253-1.92187-.55469c1.10351-3.81641,2.1455-7.71582,3.09765-11.5918l1.94141.47656C814.66973,456.75051,813.6209,460.67726,812.51055,464.51809ZM232.993,453.17336c-.96094-3.89453-1.854-7.8584-2.65576-11.7832l1.96-.4004c.7959,3.89844,1.68311,7.83692,2.63721,11.70508ZM818.27032,441.063l-1.96094-.39844c.791-3.89551,1.51367-7.86719,2.14844-11.80371l1.97461.31836C819.79375,433.14211,819.06621,437.14016,818.27032,441.063ZM228.16094,429.50832c-.64111-3.94824-1.21143-7.97168-1.69482-11.959l1.98535-.24024c.48047,3.96094,1.04687,7.957,1.68408,11.87891Zm593.95313-12.293-1.98633-.23828c.47558-3.959.87695-7.97559,1.1914-11.938l1.99414.1582C822.9959,409.18654,822.59258,413.23,822.11407,417.21535ZM225.25371,405.53273c-.32275-3.99463-.56884-8.05127-.73144-12.05761l1.99805-.08106c.16162,3.97949.40625,8.00928.72656,11.97754ZM824.032,393.14162l-1.998-.0791c.15625-3.98535.23633-8.02149.23633-11.99658l-.001-.6626h2l.001.6582C824.27032,385.06691,824.19024,389.12941,824.032,393.14162Zm-597.7622-11.74414h-2l.00049-.33594c0-3.90136.07568-7.85254.22558-11.73877l1.99805.07715c-.14844,3.86084-.22363,7.78565-.22363,11.666Zm595.73584-12.98779c-.165-3.97119-.41309-8.001-.73926-11.97657l1.99414-.16308c.32715,4.00244.57715,8.05859.74316,12.05664Zm-594.811-10.9878-1.99414-.15625c.31445-4.00488.71387-8.04882,1.18652-12.0205l1.98633.23632C227.90362,349.42678,227.50713,353.44435,227.19463,357.42189Zm592.855-12.92529c-.48242-3.94434-1.05273-7.94043-1.69726-11.877l1.97461-.32276c.64746,3.96289,1.22265,7.98584,1.707,11.95752Zm-590.02-10.89795-1.97461-.3164c.63379-3.96,1.35694-7.95948,2.15039-11.88624l1.96.39551C231.37774,325.6924,230.65948,329.66457,230.02959,333.59865Zm586.147-12.77881c-.80274-3.9082-1.69434-7.84472-2.65039-11.70166l1.9414-.48144c.96289,3.88281,1.86035,7.84668,2.668,11.78076ZM234.77618,310.08107l-1.94288-.47461c.95118-3.89257,1.9961-7.82031,3.10547-11.6748l1.92188.55322C236.7586,302.3135,235.721,306.21486,234.77618,310.08107ZM810.4041,297.53322c-1.11328-3.81982-2.32031-7.67187-3.58984-11.44873l1.89649-.63672c1.27734,3.80225,2.49316,7.68018,3.61328,11.52588ZM241.41241,287.02443l-1.89795-.63086c1.26562-3.8081,2.6289-7.64843,4.05224-11.41406l1.8711.707C244.02373,279.42726,242.66924,283.24172,241.41241,287.02443Zm561.34912-12.23388c-1.4209-3.72022-2.93262-7.45118-4.49317-11.08985l1.83789-.78808c1.57129,3.66308,3.09375,7.41894,4.52442,11.16406Zm-552.8418-10.26563-1.84082-.7832c1.57178-3.69483,3.2417-7.40967,4.96289-11.04l1.80713.85644C253.139,257.16457,251.48076,260.85451,249.91973,264.52492Zm543.40918-11.72754c-1.71191-3.585-3.52051-7.18457-5.376-10.69873l1.76758-.93408c1.86914,3.53809,3.69043,7.16162,5.41309,10.77148Zm-533.11084-9.99463-1.77148-.92871c1.86425-3.55322,3.82812-7.11865,5.83642-10.59765l1.73242,1C264.02032,235.732,262.06963,239.27394,260.21807,242.80275Zm521.92822-11.18066c-2-3.44287-4.09375-6.88721-6.22461-10.23828l1.6875-1.07324c2.14551,3.37353,4.25293,6.8413,6.2666,10.30664Zm-509.91455-9.62647-1.69043-1.06933c2.14551-3.39209,4.38916-6.78613,6.668-10.0874l1.64551,1.13623C276.59112,215.25441,274.36309,218.62551,272.23174,221.99562ZM769.28789,211.4009c-2.26855-3.26905-4.63379-6.53662-7.02929-9.71045l1.5957-1.20508c2.41211,3.19531,4.793,6.48438,7.07617,9.77588ZM285.87432,202.231l-1.59863-1.20118c2.41015-3.208,4.91748-6.40918,7.45215-9.51562l1.5498,1.26465C290.75957,195.86428,288.26885,199.04445,285.87432,202.231Zm468.96924-9.96436c-2.52246-3.07764-5.14356-6.14648-7.78809-9.12109l1.49414-1.3291c2.66309,2.99462,5.30078,6.084,7.84082,9.18261Zm-453.791-8.63428-1.49707-1.32519c2.65528-3,5.40967-5.98926,8.187-8.88477l1.44336,1.38477C306.42705,177.68312,303.69073,180.65285,301.05254,183.63234Zm437.85449-9.292c-2.76757-2.87158-5.626-5.72217-8.49707-8.47314l1.38379-1.44434c2.88965,2.76953,5.76758,5.63916,8.55274,8.52979Zm-421.24365-8.0249-1.38672-1.44141c2.88575-2.77685,5.86963-5.53467,8.86768-8.19775l1.32812,1.49512C323.494,160.81691,320.53008,163.55715,317.66338,166.31545Zm403.91748-8.57666c-2.98828-2.64209-6.06738-5.25635-9.15039-7.76953l1.26367-1.5503c3.10352,2.53028,6.20313,5.16163,9.21094,7.82178ZM335.59844,150.3882l-1.26758-1.54687c3.103-2.54151,6.29639-5.05078,9.49073-7.459l1.2041,1.59668C341.85235,145.37111,338.68047,147.86428,335.59844,150.3882Zm367.374-7.81689c-3.19043-2.39453-6.4707-4.7544-9.74707-7.01416l1.13477-1.64649c3.29883,2.27491,6.60059,4.65039,9.81348,7.061Zm-348.23095-6.61817-1.13965-1.64355c3.29687-2.28467,6.6792-4.5293,10.05322-6.67188l1.07227,1.68848C361.37578,131.45412,358.01592,133.68361,354.74151,135.95314ZM683.201,128.9385c-3.37207-2.12989-6.832-4.21924-10.28516-6.21l1-1.73242c3.47461,2.00391,6.958,4.10742,10.35352,6.25147Zm-308.23242-5.83057-1.00342-1.73047c3.458-2.00537,7.00781-3.97021,10.5498-5.83887l.9336,1.76856C381.9295,119.16359,378.40362,121.11525,374.96856,123.10793Zm287.41894-6.17139c-3.53222-1.85058-7.15136-3.65478-10.75781-5.3623l.85547-1.80762c3.63086,1.71875,7.27539,3.53516,10.83008,5.39844Zm-266.23779-5-.86084-1.80566c3.60645-1.71924,7.30029-3.39014,10.97949-4.96631l.78711,1.83838C403.40118,108.56838,399.73174,110.22805,396.14971,111.93654ZM640.66,106.6509c-3.67578-1.561-7.43164-3.06641-11.16406-4.47559l.707-1.87109c3.75684,1.41846,7.53907,2.93457,11.23828,4.50586Zm-222.51171-4.13526-.71241-1.86914c3.74219-1.42675,7.56836-2.79687,11.37207-4.07275l.63575,1.89648C425.66582,99.73732,421.86553,101.09865,418.14825,102.51564Zm200.00683-4.35986c-3.7793-1.25342-7.63574-2.44629-11.46289-3.54541l.55274-1.92187c3.85253,1.10644,7.73437,2.30712,11.53906,3.56884ZM440.89532,94.88527l-.5586-1.91992c3.84619-1.11914,7.771-2.1748,11.665-3.13818l.48047,1.9414C448.61407,92.7256,444.71563,93.77443,440.89532,94.88527ZM595.095,91.53322c-3.86133-.94189-7.80224-1.81836-11.7124-2.605l.39453-1.96094c3.93653.792,7.90381,1.67481,11.79151,2.62256ZM464.18487,89.12551l-.40137-1.959c3.9209-.80273,7.918-1.53711,11.88037-2.1831l.32227,1.97363C472.04961,87.59914,468.0794,88.32863,464.18487,89.12551ZM571.575,86.79934c-3.9331-.627-7.93164-1.18262-11.88476-1.6504l.23535-1.98632c3.97949.47119,8.00488,1.03027,11.96387,1.66211Zm-83.71093-1.53272-.24219-1.98535c3.97851-.48438,8.02148-.895,12.0166-1.21924l.16211,1.99316C495.83184,84.378,491.81573,84.78518,487.86407,85.26662Zm59.88574-1.28955c-3.96485-.30908-7.99512-.54248-11.97852-.69336l.07617-1.999c4.00977.15234,8.06641.3872,12.05762.69824Zm-35.97217-.65479-.082-1.998c3.999-.165,8.062-.252,12.07617-.25879l.00293,2C519.78741,83.07228,515.75078,83.15871,511.77764,83.32228Z",
  transform: "translate(-179.72968 -81.06545)",
  fill: "#3f3d56"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M430.42349,494.7185s-8.13458,34.8625-1.16208,34.8625,20.9175-16.26917,20.9175-16.26917v-9.29666Z",
  transform: "translate(-179.72968 -81.06545)",
  fill: "#a0616a"
});

var _ref6 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "267.544 382.858 246.627 415.396 261.734 415.396 267.544 382.858",
  fill: "#d0cde1"
});

var _ref7 =
/*#__PURE__*/
React.createElement("rect", {
  x: 254.7611,
  y: 666.40619,
  width: 27.89,
  height: 23.24167,
  fill: "#a0616a"
});

var _ref8 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "344.242 662.92 350.052 689.648 379.104 682.675 372.132 659.434 344.242 662.92",
  fill: "#a0616a"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M436.815,503.43413S427.51828,508.08246,426.3562,529s3.48625,75.53542,3.48625,75.53542-4.64833,24.40375,0,46.48333-4.64833,102.26334,1.16208,102.26334,36.02459,3.48625,37.18667,0,2.32417-55.78,2.32417-55.78,9.29667-26.72792,0-42.99709c0,0,20.9175,17.43125,20.9175,22.07959s22.07958,76.6975,32.53833,77.85958,39.51084-1.16208,33.70042-11.62083-19.75542-58.10417-19.75542-58.10417-10.45875-34.8625-29.05208-49.96958l9.29667-74.37334s19.75541-49.96958,8.13458-56.94208S436.815,503.43413,436.815,503.43413Z",
  transform: "translate(-179.72968 -81.06545)",
  fill: "#2f2e41"
});

var _ref10 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 291.94777,
  cy: 202.73492,
  r: 30.21417,
  fill: "#a0616a"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M456.57037,302.3937s11.62083,38.34875,8.13458,42.99709S501.89162,319.825,501.89162,319.825s-15.10708-10.45875-9.29667-25.56583Z",
  transform: "translate(-179.72968 -81.06545)",
  fill: "#a0616a"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M505.37787,316.3387s-13.945,4.64834-20.9175,12.78292-23.24167,9.29667-23.24167,9.29667-14.382,8.09961-19.75542,22.07958c-5.72681,14.89939-2.39816,35.8766,0,40.67292,4.64834,9.29667,4.64834,32.53833,4.64834,32.53833L440.3012,487.165s-20.9175,19.75542-4.64833,22.07958,45.32125-1.16208,62.7525,0,37.18667,3.48625,31.37625-8.13458-12.78292-19.75542-5.81042-42.99709c5.45621-18.18735,5.21954-86.18738,4.85857-114.90288a23.11814,23.11814,0,0,0-11.22732-19.53654Z",
  transform: "translate(-179.72968 -81.06545)",
  fill: "#d0cde1"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M460.05662,494.13746s-5.28709,11.6405-5.81042,18.59333c-4.06729,54.03688,25.56584,0,25.56584,0v-9.29666Z",
  transform: "translate(-179.72968 -81.06545)",
  fill: "#a0616a"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M541.40245,761.41663s-17.43125-12.78291-17.43125-5.81041-19.75541,34.8625-19.75541,34.8625-32.53834,23.24167-5.81042,23.24167,38.34875-4.64834,38.34875-4.64834l27.89-18.59333s6.9725-8.13458,4.64834-17.43125-10.45875-22.07959-10.45875-22.07959S549.537,763.7408,541.40245,761.41663Z",
  transform: "translate(-179.72968 -81.06545)",
  fill: "#2f2e41"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M439.13912,764.90288s-2.32417-11.62083-10.45875-5.81041-30.21417,23.24167-30.21417,23.24167-40.67292,9.29666-15.10708,20.9175,83.67-4.64834,83.67-4.64834,2.32417-37.18667,0-36.02458S440.3012,767.22705,439.13912,764.90288Z",
  transform: "translate(-179.72968 -81.06545)",
  fill: "#2f2e41"
});

var _ref16 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "308.798 271.879 312.284 342.766 278.503 411.185 272.773 409.005 307.636 345.09 308.798 271.879",
  opacity: 0.1
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M515.83662,331.44579l8.71563-1.74313s26.14687,19.17438,18.01229,57.52313-44.15917,96.45292-44.15917,96.45292-8.13458,10.45875-10.45875,12.78292-6.9725,0-4.64833,3.48625-3.48625,5.81041-3.48625,5.81041-25.56584,0-23.24167-9.29666,41.835-75.53542,41.835-75.53542L492.595,359.33579S487.94662,329.12162,515.83662,331.44579Z",
  transform: "translate(-179.72968 -81.06545)",
  fill: "#d0cde1"
});

var _ref18 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "347.147 357.873 347.147 349.738 307.636 414.815 347.147 357.873",
  opacity: 0.1
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M450.23813,255.81115l-4.995-1.9997s10.44395-11.49819,24.97477-10.49831l-4.08688-4.49934s9.98991-3.99933,19.0716,6.499c4.77407,5.51874,10.29773,12.00571,13.74117,19.31322h5.34924l-2.23258,4.91588,7.814,4.91588-8.02032-.883a27.20187,27.20187,0,0,1-.75859,12.73159l.215,3.88551s-9.29668-14.38389-9.29668-16.38359v4.99921s-4.99495-4.49927-4.99495-7.49878l-2.7245,3.49946L482.9322,269.309l-16.80114,5.49917,2.7245-4.49928-10.444,1.49976,4.08688-5.49916s-11.80619,6.499-12.26036,11.99813-6.35707,12.498-6.35707,12.498l-2.72449-4.99922S437.06969,263.30993,450.23813,255.81115Z",
  transform: "translate(-179.72968 -81.06545)",
  fill: "#2f2e41"
});

var _ref20 =
/*#__PURE__*/
React.createElement("rect", {
  x: 409.66414,
  y: 163.81557,
  width: 430.87649,
  height: 85.07049,
  fill: "#449e2e"
});

var _ref21 =
/*#__PURE__*/
React.createElement("rect", {
  x: 409.66414,
  y: 263.2486,
  width: 430.87649,
  height: 85.07049,
  fill: "#e6e6e6"
});

var _ref22 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 454.96141,
  cy: 205.7984,
  r: 25.41066,
  fill: "#fff"
});

var _ref23 =
/*#__PURE__*/
React.createElement("rect", {
  x: 515.72604,
  y: 195.8551,
  width: 250.79222,
  height: 5.52406,
  fill: "#fff"
});

var _ref24 =
/*#__PURE__*/
React.createElement("rect", {
  x: 515.72604,
  y: 210.21765,
  width: 250.79222,
  height: 5.52406,
  fill: "#fff"
});

var _ref25 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 454.96141,
  cy: 306.33625,
  r: 25.41066,
  fill: "#fff"
});

var _ref26 =
/*#__PURE__*/
React.createElement("rect", {
  x: 515.72604,
  y: 296.39295,
  width: 250.79222,
  height: 5.52406,
  fill: "#fff"
});

var _ref27 =
/*#__PURE__*/
React.createElement("rect", {
  x: 515.72604,
  y: 310.7555,
  width: 250.79222,
  height: 5.52406,
  fill: "#fff"
});

var _ref28 =
/*#__PURE__*/
React.createElement("rect", {
  x: 515.72604,
  y: 296.39295,
  width: 250.79222,
  height: 5.52406,
  fill: "#fff"
});

var _ref29 =
/*#__PURE__*/
React.createElement("rect", {
  x: 515.72604,
  y: 310.7555,
  width: 250.79222,
  height: 5.52406,
  fill: "#fff"
});

var _ref30 =
/*#__PURE__*/
React.createElement("rect", {
  x: 409.66414,
  y: 360.92694,
  width: 430.87649,
  height: 85.07049,
  fill: "#e6e6e6"
});

var _ref31 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 454.96141,
  cy: 404.01459,
  r: 25.41066,
  fill: "#fff"
});

var _ref32 =
/*#__PURE__*/
React.createElement("rect", {
  x: 515.72604,
  y: 394.07128,
  width: 250.79222,
  height: 5.52406,
  fill: "#fff"
});

var _ref33 =
/*#__PURE__*/
React.createElement("rect", {
  x: 515.72604,
  y: 408.43383,
  width: 250.79222,
  height: 5.52406,
  fill: "#fff"
});

var _ref34 =
/*#__PURE__*/
React.createElement("rect", {
  x: 515.72604,
  y: 394.07128,
  width: 250.79222,
  height: 5.52406,
  fill: "#fff"
});

var _ref35 =
/*#__PURE__*/
React.createElement("rect", {
  x: 515.72604,
  y: 408.43383,
  width: 250.79222,
  height: 5.52406,
  fill: "#fff"
});

var _ref36 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "452.646 215.405 443.545 203.271 445.701 201.654 453.115 211.539 482.305 187.657 484.011 189.743 452.646 215.405",
  fill: "#449e2e"
});

var SvgTodo = function SvgTodo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "f3f7ec43-b381-4c0f-aa43-60e3db23781f",
    "data-name": "Layer 1",
    width: 840.54063,
    height: 737.8691,
    viewBox: "0 0 840.54063 737.8691",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTodo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/todo.28e6a5db.svg";
export { ForwardRef as ReactComponent };